import script from "./SummaryTableConfig.vue?vue&type=script&setup=true&lang=ts"
export * from "./SummaryTableConfig.vue?vue&type=script&setup=true&lang=ts"

import "./SummaryTableConfig.vue?vue&type=style&index=0&id=400f8166&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-400f8166"]])

export default __exports__